import { Alert, Button, Card, CardBody, Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import onboardingStyle  from "../../assets/css//UserOnboarding.module.css"
import React, { useEffect, useState } from "react"; 
import QuestionnaireQuestionBlock from "../../components/ContentManagement/QuestionnaireQuestionBlock";
import { IUserQuestionnaireQuestionWithAnswer, UserFeedbackAnswer } from "../../interfaces/contentManagement/UserQuestionnaireWithAnswerOptions";
import { useUserQuestionnairesForOnboarding } from "../../hooks/useUserQuestionnaires";
import { useUserOrganisationDetail } from "../../hooks/useOrganisation";
import toast from "react-hot-toast";
import { addUserQuestionnairesFeedbacks } from "../../graphql/content-management/addUserQuestionnairesFeedbacks";
import { useMutation } from "@apollo/client";
import { LocalStorageOnBoardingDateName, LocalStorageScheduledDateName, UserOnboardingVideoTypes } from "../../helper/constants";
import { Stream } from "@cloudflare/stream-react";
import Loading from "../../components/Loading";
import { useHistory } from "react-router-dom";
import ConfettiExplosion from "react-confetti-explosion";
import { useUserOnboardingVideos } from "../../hooks/useUserOnboardingVideos";
import { UserOnboardingVideo } from "../../interfaces/models/UserOnboardingVideos";
import { Organisation } from "../../interfaces/models/Organisation";
import { updateUserSettings } from "../../graphql/user/updateUserDetails";

const UserOnboardingQuestionsPage = () => {

    let result = new Date();
    result.setDate(result.getDate() + 1);

    const [steps, setSteps]  = useState<number[]>([1,2,3]);
    const [currentStep, setCurrentStep] = useState<number>(1);
    const [lastStep, setLastStep] = useState<number>(3);

    const [isOnProcess, setIsOnProcess] = useState<boolean>(false);
    const [isDeskCoachVideoReady, setIsDeskCoachVideoReady] = useState<boolean>(false);
    const [questionnaire, setQuestionnaire] = useState<IUserQuestionnaireQuestionWithAnswer>(null);
    const [organisation, setOrganisation] = useState<Organisation>(null);
    const [videos, setVideos] = useState<UserOnboardingVideo[]>([]);
    const history = useHistory();

    const [userAnswer, setUserAnswers] = useState<UserFeedbackAnswer[]>([]);

    const [nudgeInteraction, setNudgeInteraction] = useState<boolean>(true);
    const [nudgeDelay, setNudgeDelay] = useState<number>(120);
    
    const { data, loading, error } = useUserQuestionnairesForOnboarding();
    const { data : dataOrg, loading: loadingOrg, error : errorOrg } = useUserOrganisationDetail();
    const { data : dataVideo, loading : loadingVideo, error : errorVideo } = useUserOnboardingVideos();

    const [addUserQuestionnairesFeedbacksHook] = useMutation(addUserQuestionnairesFeedbacks,{
        onCompleted : () =>{
            toast.success("Thanks for your feedback! We truly appreciate your input.");
        },
        onError : () =>{
            toast.error("Something went wrong whilst accepting your feedback . Please try again or if issue persists, please contact us");
        }
    });

    const [updateUserSettingsHook] = useMutation(updateUserSettings,{
        onCompleted : () =>{
        },
        onError : () =>{
            toast.error("Something went wrong whilst updating your settings . Please try again or if issue persists, please contact us");
        }
    });

    useEffect(() => {
        if(data ) {
            if(data.user_questionnaire_onboarding) {
                setQuestionnaire(data.user_questionnaire_onboarding);
            }
            else {
                history.push(`dash/user`);
            }
            
        }
    },[data, history]);

    useEffect(() => {
        if(dataOrg) {
            if(dataOrg.me) {
                setOrganisation(dataOrg.me.organisation);
                if(dataOrg.me.organisation.allow_user_customisation) {
                    setSteps([1,2,3,4]);
                    setLastStep(4);
                }
            }
        }
    },[dataOrg]);

    useEffect(() => {
        if(dataVideo) { 
            setVideos(dataVideo.user_onboarding_videos);
        }
    },[dataVideo])

    const HandleChange = (answers : UserFeedbackAnswer[]) => {
        setUserAnswers(answers);
    }

    const HandleConfirm = async () => {

        setIsOnProcess(true);

        const isUpdated = await updateUserSettingsHook({
            variables : {
                nudge_delay : nudgeDelay,
                nudge_interaction : nudgeInteraction
            }
        });

        if(!isUpdated) {
            setIsOnProcess(false);
            return;
        }

        const isAdded = await addUserQuestionnairesFeedbacksHook({
            variables : {
                record : {
                    questionnaire_id : questionnaire._id,
                    answers : userAnswer
                }
            }
        });

        if(!isAdded) {
            setIsOnProcess(false);
            return;
        }
        setIsOnProcess(false);

        SetToAnswerNextDay();
        window.localStorage.setItem(LocalStorageScheduledDateName, result.toString());
        setTimeout(() => {
            window.location.href = "/dash/user";
        },700);

    }

    const SetToAnswerNextDay = () => {
        window.localStorage.setItem(LocalStorageOnBoardingDateName, result.toString());
    }

    const ChangeStep = (step : number) => {
        if(step === 3) {
            if(userAnswer.length !== questionnaire.questions.length) {
                toast.error("Sorry please answer all the question to proceed");
                return;
            }
        }
        setCurrentStep(step);
    }


    return (
        <Container className="pt-5">
            <Row className="pt-5">
                <Col>
                    
                <div className={onboardingStyle.wizard}>
                    {
                        steps.map((item,key) => 
                            <React.Fragment key={key}>
                                <div className={onboardingStyle.wizardStep  + (item < currentStep  || currentStep === steps.length ?  " " + onboardingStyle.wizardStepSuccess : "")} >
                                    { item < currentStep  || currentStep === steps.length ? <i className="fas fa-check"></i> : item === currentStep ? <i className="fas fa-map-marker-alt"></i> : item}
                                </div>
                                {
                                    key + 1 < steps.length &&
                                    <div className={onboardingStyle.wizardLine + (item < currentStep  || currentStep === steps.length  ?  " " + onboardingStyle.wizardLineSuccess : "")}></div>
                                }
                            </React.Fragment>
                        )
                    }
                </div>
                <Card className="m-2">
                    <CardBody   >
                        {
                            currentStep === 1 &&
                            <div>
                                <h1>Welcome desk.coach!</h1>
                                {
                                    errorVideo &&
                                    <Alert color="danger">
                                        Oops, we’re having trouble getting the Video. Please give it a minute, and if it doesn’t resolve, let us know.
                                    </Alert>
                                } 
                                {
                                    !isDeskCoachVideoReady &&
                                    <Loading />
                                }
                                {
                                    videos.length !== 0 &&
                                    <div  className={onboardingStyle.steamHeight + (isDeskCoachVideoReady ? "" : " d-none")}>
                                        <Stream controls autoplay={false} src={videos.find(u => u.video_type === UserOnboardingVideoTypes.NUDGE).video_id} onCanPlay={() => setIsDeskCoachVideoReady(true)}/>
                                    
                                    </div>
                                }
                                
                            </div>
                        }
                        {
                            currentStep === 2 &&
                            <div style={{minHeight:700}}>
                                <h1>Getting to know you!</h1>
                                {
                                    error &&
                                    <Alert color="danger">
                                        Oops, we’re having trouble getting the Questions. Please give it a minute, and if it doesn’t resolve, let us know.
                                    </Alert>
                                } 
                                {
                                    loading &&
                                    <Loading />
                                }
                                {
                                    questionnaire && 
                                    <QuestionnaireQuestionBlock  questionnaires={questionnaire} handleAnswers={HandleChange} />
                                }
                            </div>
                        }
                        {/* {
                            currentStep === 3 &&
                            <div>
                                <h1>How to Use Empower ME?</h1>
                                {
                                    errorVideo &&
                                    <Alert color="danger">
                                        Oops, we’re having trouble getting the Video. Please give it a minute, and if it doesn’t resolve, let us know.
                                    </Alert>
                                } 
                                {
                                    !isEmpowerMeVideoReady &&
                                    <Loading />
                                }
                                {
                                    videos.length !== 0 &&
                                    <div  className={onboardingStyle.steamHeight + (isEmpowerMeVideoReady ? "" : " d-none")}>
                                        <Stream controls autoplay={false} src={videos.find(u => u.video_type === UserOnboardingVideoTypes.EMPOWER_ME).video_id} onCanPlay={() => setIsEmpowerMeVideoReady(true)}/>
                                    
                                    </div>
                                }
                            </div>
                        } */}
                        {
                            currentStep === 3 && organisation.allow_user_customisation &&
                            <div>
                                <h1>Customise your Nudges</h1>
                                <FormGroup>
                                    <Label>Nudge Delay</Label>
                                    <Input type="select" value={nudgeDelay} onChange={(e) => setNudgeDelay(Number(e.currentTarget.value))} >
                                        <option value="60">1 Hour</option>
                                        <option value="120">2 Hours (Default)</option>
                                        <option value="240">4 Hours</option>
                                    </Input>
                                    <small className="text-muted">Set the delay interval for your nudges</small>
                                </FormGroup>
                                <FormGroup>
                                    <label>Nudge Interaction</label>
                                    <div>
                                        <small className="text-primary">NOTE: Changes from this will apply on your next working day. </small>
                                    </div>
                                    <Input type="select" value={nudgeInteraction.toString().toLowerCase()} onChange={(e)=>setNudgeInteraction(e.currentTarget.value === "true")} >
                                        <option value="true">ON (Default)</option>
                                        <option value="false">OFF</option>
                                    </Input>
                                    <small className="text-muted">This option controls how nudges behave. If turned off, nudges will proceed without any interaction from you. </small>
                                </FormGroup> 
                            </div>
                        }
                        {
                            currentStep === lastStep &&
                            <div >
                                <ConfettiExplosion
                                    style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: "50%",
                                    }}
                                    width={2000}
                                    duration={4400}
                                    particleCount={220}
                                />
                                <h1>Congratulations!</h1>
                                <p className="text-center">
                                    You're all set! You've successfully completed the onboarding process and are now ready to make the most of desk.coach
                                </p>
                                <p className="text-center">
                                    Explore its features, customise your settings, and start using it with ease. If you ever need help, our support team and help & center page will be be here.
                                </p>
                                <div className="text-center font-weight-bold">
                                    Welcome to desk.coach!
                                </div>
                                <div className="text-center pt-5">
                                    <Button color="primary" size="lg" disabled={isOnProcess} onClick={HandleConfirm}>START USING THE APP</Button>
                                </div>
                            </div>
                        }
                        
                        <div className="d-flex justify-content-end pt-5">
                            <div>
                                {
                                    currentStep < steps.length && !error && questionnaire && !loadingVideo && isDeskCoachVideoReady && !loadingOrg && !errorOrg &&
                                    <Button size="lg" disabled={isOnProcess} onClick={() => ChangeStep(currentStep + 1)}>Next <i className="fas fa-long-arrow-alt-right"></i> </Button>
                                }
                            </div>
                        </div>
                    </CardBody>
                </Card>

                </Col>
            </Row>
        </Container>
    )
}

export { UserOnboardingQuestionsPage as UserOnboardingQuestions };